import React from "react";
import { Link } from "react-router-dom";
import { siteConfig, footerLinks } from "../constants";
import Logo from "./Logo";
import CoffeeTip from "./CoffeeTip";
import colors from "../theme/colors";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const linkStyle = {
    color: colors.textMuted,
    textDecoration: "none",
    transition: "color 0.2s ease",
  };

  return (
    <footer className="relative" style={{ backgroundColor: colors.bgCard, borderTop: `1px solid ${colors.bgBorder}` }}>
      <div className="mx-auto w-full max-w-[1200px] px-6 py-14">
        <div
          className="grid gap-10 rounded-2xl border p-8 md:grid-cols-2 lg:grid-cols-4"
          style={{ borderColor: colors.bgBorder, backgroundColor: colors.bgCard }}
        >
          <div>
            <Logo variant="compact" navBrand />
            <p className="mt-4 text-sm leading-7" style={{ color: colors.textMuted }}>
              {siteConfig.siteDescription}
            </p>
            <div className="mt-4">
              <CoffeeTip className="footer-variant" />
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.15em]" style={{ color: colors.accentCyan }}>
              Services
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = colors.accentCyan;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = colors.textMuted;
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.15em]" style={{ color: colors.accentCyan }}>
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              {footerLinks.quickLinks.map((link, index) => (
                <li key={index}>
                  {link.path.startsWith("#") ? (
                    <a
                      href={link.path}
                      style={linkStyle}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = colors.accentCyan;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = colors.textMuted;
                      }}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.path}
                      style={linkStyle}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = colors.accentCyan;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = colors.textMuted;
                      }}
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.15em]" style={{ color: colors.accentCyan }}>
              Contact & Social
            </h3>
            <ul className="mt-4 space-y-2 text-sm" style={{ color: colors.textMuted }}>
              <li>
                <a
                  style={linkStyle}
                  href="https://www.linkedin.com/in/mkmalani/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.accentCyan;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textMuted;
                  }}
                >
                  LinkedIn
                </a>
              </li>
              
            </ul>
          </div>
        </div>

      </div>
      <div className="border-t py-6 text-xs" style={{ borderColor: colors.bgBorder, backgroundColor: colors.bgPrimary, color: colors.textHint }}>
        <div className="mx-auto w-full max-w-[1200px] px-6">
          <p className="m-0">
            &copy; {currentYear} {siteConfig.siteName}. All rights reserved.
          </p>
          <p className="mt-2 mb-0">
            Professional server hosting, email services, MongoDB and SMTP setup by expert team.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
